/**
 * SGKC006A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TankatableLstInformationDto {

    /**
     * 単価表登録管理通番
     */
    tankatableregistrationManagementserialnumber?: string;
    /**
     * 単価表コード
     */
    tankatableCode?: string;
    /**
     * 単価表名称
     */
    tankatableAname?: string;
    /**
     * 適用開始日付
     */
    applyStartDate?: string;
    /**
     * 適用終了日付
     */
    applyEndDate?: string;
    /**
     * 単価表説明
     */
    tankatableExplanation?: string;
    /**
     * 承認ステータスコード
     */
    apprvStatuscode?: string;
    /**
     * 承認ステータス名称
     */
    apprvStsAname?: string;
}

